import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {EcpAntUiComponent} from './ecp-ant-ui.component';
import {CommonModule} from '@angular/common';
/* åºç¡ç»ä»¶ */
import {BreadCrumbComponent} from './bread-crumb/bread-crumb.component';
import {CopyrightComponent} from './copyright/copyright.component';

/* å·¦è¾¹å¯¼èª */
import {NavBarComponent} from './nav-bar/nav-bar.component';


import {HelpInfoComponent} from './layouts/flex-tcb-module/help-info/help-info.component'; // æ é¢çå¸®å©æç¤º

/**/
import {CardInfoComponent} from './card-info/card-info.component';
/* å·¦è¾¹å¯¼èª */
import {PageLeftNavComponent} from './page-left-nav/page-left-nav.component';
/* æç´¢æ¨¡å */
import {SeachModuleComponent} from './seach-module/seach-module.component';
/* æ°æ®è¡¨æ ¼ */
import {ListComponent} from './dataTable-module/list/list.component';
/* httpç¶æ */
import {HttpStatusPageComponent} from './httpPage/http-status-page/http-status-page.component';
/* ä¿®æ¹antæ¡æ¶tagsæ ç­¾æ ·å¼ */
import {EcpAntTagsComponent} from './ecp-ant-tags/ecp-ant-tags.component';
/**/
/* å°å¾ç¨ */
import {LegendComponent} from './map/legend/legend.component';
import {RippleComponent} from './map/ripple/ripple.component';
import {MapDotPopupComponent} from './map/map-dot-popup/map-dot-popup.component';
import {SelectMapTypeComponent} from './select-map-type/select-map-type.component';
/**/
import {ToolBarComponent} from './tool-bar/tool-bar.component';
import {ToolBar2Component} from './tool-bar2/tool-bar2.component';
import {ToolBar3Component} from './tool-bar3/tool-bar3.component';
import {StatusBarComponent} from './status-bar/status-bar.component';
import {TabsComponent} from './tabs-module/tabs/tabs.component';
import {TabComponent} from './tabs-module/tab/tab.component';
import {UploadFileComponent} from './upload-file/upload-file.component';
import {EcpTemplateComponent} from './ecp-template/ecp-template.component';


import {MapSwitchComponent} from './map-switch/map-switch.component';

import {MapInfoCardComponent} from './map/map-info-card/map-info-card.component';
import {MapDotComponent} from './map/map-dot/map-dot.component';
import {MultistageSelectComponent} from './multistage-select/multistage-select.component';
import {RichTextToPageComponent} from './rich-text/rich-text-to-page/rich-text-to-page.component';
import {ArraySortComponent} from './array-sort/array-sort.component';
import {NavBarWhiteComponent} from './nav-bar-white/nav-bar-white.component';
import {ArrSortComponent} from './arr-sort/arr-sort.component';

/* ææ½ç»ä»¶ */
import {DragulaModule} from 'ng2-dragula';
import {DragulaComponent} from './dragula/dragula.component';
import {NgZorroAntdModule} from 'ng-zorro-antd';


import {StepModule} from './step/step.module';
import {LayoutsModule} from './layouts/layouts.module';
import {NavModule} from './nav/nav.module';
import { EcpMenuComponent } from './ecp-menu/ecp-menu.component';


@NgModule({
    imports: [CommonModule,
        // ä¾èµæ¨¡å
        DragulaModule.forRoot(),
        NgZorroAntdModule,
    ],
    declarations: [EcpAntUiComponent,

        BreadCrumbComponent,
        CopyrightComponent,
        /**/
        NavBarComponent,
        /**/
        HelpInfoComponent,
        CardInfoComponent,
        /**/
        PageLeftNavComponent,
        /**/
        SeachModuleComponent,
        /**/
        ListComponent,
        /**/
        HttpStatusPageComponent,
        /**/

        EcpAntTagsComponent,
        /**/
        LegendComponent,
        RippleComponent,
        MapDotPopupComponent,
        SelectMapTypeComponent,
        /**/
        ToolBarComponent,
        ToolBar2Component,
        ToolBar3Component,
        StatusBarComponent,
        TabsComponent,
        TabComponent,
        UploadFileComponent,
        EcpTemplateComponent,

        MapSwitchComponent,



        MapInfoCardComponent,

        MapDotComponent,

        MultistageSelectComponent,

        RichTextToPageComponent,

        ArraySortComponent,

        NavBarWhiteComponent,

        ArrSortComponent,

        DragulaComponent,

        EcpMenuComponent,




    ],
    exports: [
        StepModule,
        LayoutsModule,
        NavModule,
        BreadCrumbComponent,
        CopyrightComponent,
        /**/

        NavBarComponent,
        NavBarWhiteComponent,
        EcpMenuComponent,

        HelpInfoComponent,
        /**/
        PageLeftNavComponent,
        /**/
        SeachModuleComponent,
        /**/
        ListComponent,
        /**/
        HttpStatusPageComponent,
        CardInfoComponent,
        EcpAntTagsComponent,
        /*å°å¾ç»ä»¶*/
        LegendComponent,
        RippleComponent,
        MapDotPopupComponent,
        SelectMapTypeComponent,
        MapInfoCardComponent,
        MapDotComponent,

        MultistageSelectComponent,
        // ç¶ææ¡
        StatusBarComponent,
        // å¯ææ¬
        RichTextToPageComponent,
        // ææ½
        DragulaComponent,
        // æ­¥éª¤çæç»ä»¶


        /* ä»¥ä¸ç»ä»¶å¨ä½äºecp-ant-ui v1.0.0 ççæ¬ä¸­ä¸æä¾ */


/*
        ToolBarComponent,
        ToolBar2Component,
        ToolBar3Component,

        TabsComponent,
        TabComponent,
        UploadFileComponent,
        EcpTemplateComponent,
        MapSwitchComponent,
        ArraySortComponent,
        EcpMenuComponent,*/


        /*  --------------------------------------  */
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EcpAntUiModule {
}
